import { useUsers } from './useUsers';

function useCurrentUser() {
    const { users } = useUsers();

    if (users?.length >= 1) {
        const currentUser = users.find((u) => u.isSelf);
        return currentUser;
    }
    
    return undefined;
}

export default useCurrentUser;
